import { Injectable } from '@angular/core';
import { Router, CanActivate, CanLoad } from '@angular/router';
import { AuthenticationService, Logger } from '@app/core';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

const logger = new Logger('GuestGuard');

@Injectable()
export class OnlyGuestGuard implements CanActivate, CanLoad {

  constructor(private router: Router,
              private authenticationService: AuthenticationService) { }

  canActivate(): boolean | Observable<boolean> {
    if (!this.authenticationService.isAuthenticated()) {
      return true;
    }

    return of(true).delay(1000).pipe(map(() => {
      if (!this.authenticationService.isAuthenticated()) {
        return true;
      }
      this.router.navigate(['/home', { outlets: { modal: null }}], { replaceUrl: true });
      return false;
    }));
  }

  canLoad(): boolean | Observable<boolean> {
    if (!this.authenticationService.isAuthenticated()) {
      return true;
    }

    return of(true).delay(1000).pipe(map(() => {
      if (!this.authenticationService.isAuthenticated()) {
        return true;
      }
      this.router.navigate(['/home', { outlets: { modal: null }}], { replaceUrl: true });
      return false;
    }));
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/authentication/only-guest.guard.ts